module.exports = __webpack_public_path__ + "static/img/shebei.759a0d63.png";